import * as React from 'react';

function SvgSelfManagedModal(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width='352' height='280' viewBox='0 0 352 280' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#SelfManagedModal_svg__clip0_37618_578201)'>
        <path
          d='M164.903 188.565h-3.594v-1.198h3.594v1.198zm-7.189 0h-3.594v-1.198h3.594v1.198zm-7.188 0h-3.594v-1.198h3.594v1.198zm-7.188 0h-3.594v-1.198h3.594v1.198zm-7.188 0h-3.595v-1.198h3.595v1.198zm-7.189 0h-3.594v-1.198h3.594v1.198zm-7.188 0h-3.594v-1.198h3.594v1.198zm-7.188 0h-3.594v-1.198h3.594v1.198zm-7.189 0h-3.594v-1.198h3.594v1.198zm-7.188 0h-3.594v-1.198h3.594v1.198zm-7.188 0h-3.594v-1.198h3.594v1.198zm-7.188 0h-3.595v-1.198h3.595v1.198zm-7.189 0H75.05v-1.198h3.594v1.198zm-7.188 0h-3.594v-1.198h3.594v1.198zM134.698 166.433l-2.899-2.124.708-.967 2.899 2.125-.708.966zm-5.798-4.249l-2.899-2.125.708-.966 2.899 2.125-.708.966zm-5.798-4.249l-2.899-2.125.708-.966 2.899 2.124-.708.967zm-5.798-4.25l-2.899-2.124.708-.967 2.899 2.125-.708.966zm-5.798-4.249l-2.899-2.125.709-.966 2.899 2.125-.709.966zm-5.797-4.249l-2.899-2.125.708-.966 2.899 2.124-.708.967zm-5.798-4.25l-2.9-2.124.71-.967 2.898 2.125-.708.966zm-5.798-4.249l-2.899-2.125.708-.966 2.9 2.125-.709.966zm-5.798-4.249l-2.899-2.125.709-.966 2.898 2.124-.708.967zM312.01 124.341v3.594h-1.198v-3.594h1.198zm0 7.188v3.594h-1.198v-3.594h1.198zm0 7.189v3.594h-1.198v-3.594h1.198zm0 7.188v3.594h-1.198v-3.594h1.198zm0 7.188v3.594h-1.198v-3.594h1.198zm0 7.188v3.595h-1.198v-3.595h1.198zm0 7.189v3.594h-1.198v-3.594h1.198zm0 7.188v3.594h-1.198v-3.594h1.198zm0 7.188v3.594h-1.198v-3.594h1.198zM86.198 126.729H85v-3.594h1.198v3.594zm0-7.189H85v-3.594h1.198v3.594zm0-7.188H85v-3.594h1.198v3.594zm0-7.188H85v-3.594h1.198v3.594zm0-7.188H85V94.38h1.198v3.595zm0-7.189H85v-3.594h1.198v3.594zm65.953-6.589h-1.857V83h1.857v1.198zm-5.452 0h-3.594V83h3.594v1.198zm-7.188 0h-3.594V83h3.594v1.198zm-7.188 0h-3.594V83h3.594v1.198zm-7.188 0h-3.595V83h3.595v1.198zm-7.189 0h-3.594V83h3.594v1.198zm-7.188 0h-3.594V83h3.594v1.198zm-7.188 0h-3.594V83h3.594v1.198zm-7.189 0h-3.594V83h3.594v1.198zm-7.188 0H85.6V83h3.594v1.198zM224.198 197.729H223v-3.594h1.198v3.594zm0-7.189H223v-3.594h1.198v3.594zm0-7.188H223v-3.594h1.198v3.594zm0-7.188H223v-3.594h1.198v3.594zm0-7.188H223v-3.595h1.198v3.595zm0-7.189H223v-3.594h1.198v3.594zm65.953-6.589h-1.857V154h1.857v1.198zm-5.452 0h-3.594V154h3.594v1.198zm-7.188 0h-3.594V154h3.594v1.198zm-7.188 0h-3.594V154h3.594v1.198zm-7.188 0h-3.595V154h3.595v1.198zm-7.189 0h-3.594V154h3.594v1.198zm-7.188 0h-3.594V154h3.594v1.198zm-7.188 0h-3.594V154h3.594v1.198zm-7.189 0h-3.594V154h3.594v1.198zm-7.188 0h-3.594V154h3.594v1.198z'
          fill='#B09FA3'
        />
        <g filter='url(#SelfManagedModal_svg__filter0_d_37618_578201)'>
          <path
            d='M166.177 108.355c14.458 0 26.178-11.72 26.178-26.178 0-14.457-11.72-26.177-26.178-26.177C151.72 56 140 67.72 140 82.177c0 14.458 11.72 26.178 26.177 26.178z'
            fill='#fff'
          />
        </g>
        <path
          d='M174.022 88.883c0 2.216 0 8.206-.12 8.865-.119.959-1.377 1.438-2.875 1.917-.659.18-1.497.539-1.438.839.06.299 5.152.18 5.152.18s5.092.179 5.152-.18c.06-.3-.779-.66-1.438-.839-1.498-.479-2.696-.958-2.875-1.917-.12-.659-.12-6.649-.12-8.865h-1.438z'
          fill='#00385E'
        />
        <path
          d='M174.742 89.662c-2.935.06-5.93-2.097-6.41-6.17-.479-4.073 2.636-10.183 2.636-10.183h7.668s3.114 6.11 2.635 10.183c-.539 4.073-3.594 6.23-6.529 6.17z'
          fill='#00385E'
        />
        <path
          d='M170.19 79.84h9.165s.599 2.156.299 4.133c-.359 2.336-1.497 4.073-4.852 4.193-1.917 0-6.11-1.258-4.612-8.326z'
          fill='#E97B5E'
        />
        <path
          d='M160.485 65.281h-1.737s.119 3.235-.42 5.152c-.539 1.917-3.115 3.534-3.115 5.93v23.182s.54 1.079 1.378 1.079h7.787c.839 0 1.378-1.079 1.378-1.079V76.363c0-2.456-2.576-4.073-3.115-5.93-.539-1.917-.419-5.152-.419-5.152h-1.737z'
          fill='#00385E'
        />
        <path d='M162.522 61.09h-4.193v8.087h4.193V61.09z' fill='#E97B5E' />
        <path d='M161.983 80.258h-6.829v12.04h6.829v-12.04z' fill='#DADADA' />
        <path d='M159.946 88.106h-4.792v2.396h4.792v-2.396z' fill='#F8AD38' />
        <g filter='url(#SelfManagedModal_svg__filter1_d_37618_578201)'>
          <path
            d='M170.355 174.177c0 14.437-11.741 26.178-26.178 26.178-14.436 0-26.177-11.741-26.177-26.178C118 159.741 129.741 148 144.177 148c14.437 0 26.178 11.741 26.178 26.177z'
            fill='#fff'
          />
        </g>
        <g clipPath='url(#SelfManagedModal_svg__clip1_37618_578201)'>
          <path d='M121.795 171.122s8.31-18.555 33.502 5.281c0 0-27.526 14.73-33.502-5.281z' fill='#8CAEB0' />
          <path
            d='M164.795 171.706c-4.85-.971-11.671 2.428-11.671 2.428l-1.71-.263-.242 1.659 8.472 1.255 5.151-5.079zM163.125 183.139l-3.501-6.353-8.451-1.255-.242 1.659 1.71.243s5.574 5.221 10.484 5.706z'
            fill='#8CAEB0'
          />
          <path d='M126.966 178.93s11.148-1.437 5.815-14.791c0 0-6.901-.466-10.986 6.96 0 .02 1.771 6.172 5.171 7.831z' fill='#BEDDDB' />
          <path
            d='M126.121 170.451h-.061a1.002 1.002 0 01.282-1.983h.06c.544.081.926.587.846 1.133a1.03 1.03 0 01-1.127.85z'
            fill='#95A5A6'
          />
          <path
            d='M126.121 170.047h-.04a.651.651 0 01-.564-.749.65.65 0 01.745-.567h.04a.651.651 0 01.564.749c-.061.364-.383.627-.745.567z'
            fill='#fff'
          />
          <path
            d='M133.646 174.075l8.109-.02-4.607 1.052 2.555.384-8.552 1.74s1.892-1.396 2.495-3.156zM121.855 170.977s1.993.283 2.274 1.315l-2.274-1.315z'
            fill='#677070'
          />
          <path
            d='M156.625 172.739s4.488-1.78 8.17-1.032l-5.171 5.079 3.501 6.354s-3.079-.081-7.164-3.076l1.63-3.622-.966-3.703z'
            fill='#485D66'
          />
        </g>
        <g filter='url(#SelfManagedModal_svg__filter2_d_37618_578201)'>
          <path
            d='M246.355 150.177c0 14.437-11.741 26.178-26.178 26.178-14.436 0-26.177-11.741-26.177-26.178C194 135.741 205.741 124 220.177 124c14.437 0 26.178 11.681 26.178 26.177z'
            fill='#fff'
          />
        </g>
        <path
          d='M224.167 142.418a.86.86 0 01-.236-.047c-.285-.119-.379-.45-.261-.735l2.866-6.064c.119-.284.45-.379.735-.26.284.118.379.45.26.734l-2.866 6.064a.552.552 0 01-.498.308z'
          fill='#31A88E'
        />
        <path
          d='M225.02 143.485c-.45.426-1.327.213-1.943-.45-.616-.664-.781-1.54-.331-1.967.45-.426 1.326-.213 1.942.451.616.663.782 1.563.332 1.966z'
          fill='#FFC466'
        />
        <path
          d='M220.557 156.019c4.958-3.918 6.629-10.065 3.733-13.73-2.896-3.664-9.263-3.458-14.221.46s-6.629 10.065-3.733 13.73c2.896 3.664 9.263 3.459 14.221-.46z'
          fill='#FFE787'
        />
        <path d='M205.122 153.125s-1.492 2.985-.687 4.453c.829 1.469 5.212.356 5.212.356l-4.525-4.809z' fill='#FFE787' />
        <path
          d='M225.209 140.214a.535.535 0 01-.497-.331.576.576 0 01.261-.734l3.387-1.564a.576.576 0 01.734.261.575.575 0 01-.26.734l-3.388 1.563c-.071.071-.165.071-.237.071z'
          fill='#31A88E'
        />
        <path d='M228.597 137.61s5.78-1.208 12.294 4.525c0 0-1.09-.072-1.99.142-3.103.758-9.594 1.918-10.304-4.667z' fill='#31A88E' />
        <path
          d='M212.892 156.039a.523.523 0 01-.45.568.523.523 0 01-.568-.45.523.523 0 01.45-.568c.284-.048.521.165.568.45zM216.658 153.479a.524.524 0 01-.45.569.523.523 0 01-.568-.45.524.524 0 01.45-.569c.284-.023.545.166.568.45zM220.449 150.921a.524.524 0 01-.451.568.523.523 0 01-.568-.45c-.047-.284.166-.521.45-.568a.525.525 0 01.569.45zM223.622 147.464a.523.523 0 01-.45.568.523.523 0 01-.568-.45.523.523 0 01.45-.568.542.542 0 01.568.45zM216.113 156.464a.523.523 0 01-.45.568.523.523 0 01-.568-.45.523.523 0 01.45-.568c.308-.024.545.166.568.45z'
          fill='#FFC466'
        />
        <path
          d='M219.903 153.905a.524.524 0 01-.45.569.524.524 0 01-.568-.45.524.524 0 01.45-.569c.284-.024.545.166.568.45zM223.67 151.347a.524.524 0 01-.451.568.523.523 0 01-.568-.45.523.523 0 01.45-.568c.284-.024.545.165.569.45z'
          fill='#F39C12'
        />
        <path
          d='M240.891 142.158c-6.491-5.733-12.294-4.524-12.294-4.524 0 .071.023.118.023.165l12.081 4.335c.119 0 .19.024.19.024z'
          fill='#116B52'
        />
        <path
          d='M231.315 153.254a.346.346 0 01-.308-.165.38.38 0 01.095-.522c.142-.094 3.316-2.226 6.159-.379a.41.41 0 01.118.522.41.41 0 01-.521.118c-2.44-1.587-5.282.355-5.306.355a.523.523 0 01-.237.071zM228.259 152.425c-1.895-3.791 1.113-5.425 1.113-5.425 2.748 5.235-.71 6.112-.71 6.112l-.403-.687z'
          fill='#20CC9C'
        />
        <path d='M230.58 152.969c4.169-.805 4.927 2.535 4.927 2.535-5.78 1.231-5.709-2.322-5.709-2.322l.782-.213z' fill='#20CC9C' />
        <path d='M228.851 152.186c2.44-3.459 5.307-1.611 5.307-1.611-3.293 4.903-5.709 2.298-5.709 2.298l.402-.687z' fill='#20CC9C' />
        <path
          d='M232.689 153.421c-.071-.166-.758-2.298-4.809-3.316-1.397-.356-3.648.071-5.14 1.042-3.103 2.061-3.056 5.448-3.648 8.196-.047.403-.284 1.966.26 2.44.972.853 1.659.829 3.127.639 2.559-.331 5.283.403 8.552-1.918 2.605-1.848 2.7-4.667 1.658-7.083z'
          fill='#F49177'
        />
        <path
          d='M228.33 153.205c-.285.332-.735.545-.995.498-.261-.048-.237-.356.047-.687.284-.332.735-.545.995-.498.261.048.237.356-.047.687zM228.733 155.813c-.237.356-.663.616-.924.593-.26-.024-.284-.332-.023-.687.236-.356.663-.616.923-.593.237.024.261.332.024.687zM226.459 158.466c-.237.355-.664.616-.924.592-.261-.024-.284-.332-.024-.687.237-.355.663-.616.924-.592.261.024.261.331.024.687zM222.574 155.645c-.237.356-.663.616-.923.593-.261-.024-.285-.332-.024-.687.237-.356.663-.616.924-.592.26.023.284.331.023.686zM225.251 155.669c-.261.332-.711.569-.972.545-.26-.047-.26-.355 0-.687.261-.332.711-.569.972-.545.284.047.26.355 0 .687zM223.143 158.514c-.285.331-.735.545-.995.497-.261-.047-.237-.355.047-.687.284-.331.735-.544.995-.497.261.047.237.355-.047.687zM225.251 152.971c-.284.332-.734.545-.995.497-.26-.047-.237-.355.048-.687.284-.331.734-.544.994-.497.261.071.237.379-.047.687zM224.421 161.996s4.809-.284 6.704-2.156c2.701-2.629 1.256-4.856 1.256-4.856s-.19 2.677-2.274 4.335c-2.038 1.611-5.686 2.677-5.686 2.677z'
          fill='#EC7050'
        />
        <path
          d='M73.035 165.556c0 11.441-5.149 21.683-13.269 28.551-6.533 5.508-14.958 8.84-24.177 8.84a37.354 37.354 0 01-21.877-7.031c-9.443-6.787-15.569-17.863-15.569-30.36 0-20.647 16.77-37.392 37.446-37.392 20.697 0 37.446 16.745 37.446 37.392z'
          fill='#F3F5F9'
        />
        <path d='M29.952 176.324l-.101 9.287-.306 5.629 13.595-.386-.773-14.632-12.618-.488.203.59z' fill='#EDBFB2' />
        <path
          d='M29.361 191.422l.306-5.812.101-9.267-.264-.792 13.045.508.794 14.977-13.982.386zm.631-15.505l.122.365-.101 9.328-.285 5.446 13.207-.386-.753-14.286-12.19-.467z'
          fill='#EDBFB2'
        />
        <path
          d='M23.156 154.459s-2.91 26.357 12.434 26.764c15.345.386 13.004-27.15 13.004-27.15s-.203-8.535-10.297-9.307c-10.074-.772-13.188 3.495-15.141 9.693z'
          fill='#FFD2BA'
        />
        <path
          d='M35.915 181.385h-.326c-3.215-.081-5.881-1.301-7.916-3.638-6.35-7.254-4.681-23.125-4.66-23.288v-.02c2.014-6.442 5.392-10.568 15.303-9.816 10.114.773 10.44 9.369 10.44 9.47.02.163 1.364 17.009-5.352 24.122-1.995 2.093-4.518 3.17-7.49 3.17zM23.317 154.5c-.06.569-1.587 15.972 4.6 23.024 1.974 2.256 4.558 3.455 7.692 3.536 3.012.081 5.577-.955 7.571-3.069 6.614-7.011 5.291-23.715 5.27-23.898 0-.345-.304-8.413-10.134-9.165-9.748-.752-12.964 3.109-14.999 9.572z'
          fill='#FFD2BA'
        />
        <path
          d='M28.384 152.368l15.426.386s5.332 2.317 3.398 14.144h1.649s4.274-23.166 1.75-25.097c-2.523-1.93-15.528-6.401-23.689.102-8.16 6.503-4.66 25.503-4.66 25.503l1.649.386c.02 0 1.465-15.22 4.477-15.424z'
          fill='#152144'
        />
        <path
          d='M24.049 167.974l-1.913-.447-.02-.102c-.041-.183-3.42-19.163 4.72-25.625 8.1-6.463 21.044-2.256 23.873-.102 2.564 1.971-1.527 24.304-1.69 25.239l-.02.122h-1.933l.02-.162c1.832-11.177-2.91-13.799-3.297-13.982l-15.406-.386c-2.36.163-3.927 11.096-4.314 15.282l-.02.163zm-1.649-.691l1.404.325c.184-1.748 1.629-15.18 4.58-15.383l15.466.386.02.02c.224.102 5.373 2.479 3.501 14.144h1.363c1.466-8.007 3.704-23.37 1.771-24.853-1.241-.956-5.047-2.541-9.667-3.089-3.907-.468-9.483-.285-13.838 3.17-7.673 6.157-4.844 23.817-4.6 25.28z'
          fill='#152144'
        />
        <path d='M46.822 162.121s5.312-3.191 4.742 4.064c-.59 7.275-5.76 3.414-5.76 3.414l1.018-7.478z' fill='#FFD2BA' />
        <path
          d='M48.592 170.775c-1.425 0-2.788-.995-2.87-1.056l-.08-.061 1.037-7.662.061-.04c.081-.061 2.198-1.301 3.684-.386 1.038.65 1.485 2.194 1.282 4.613-.184 2.357-.875 3.84-2.056 4.369a2.488 2.488 0 01-1.058.223zm-2.605-1.26c.387.265 2.157 1.382 3.541.752 1.058-.487 1.69-1.869 1.872-4.105.184-2.276-.203-3.739-1.14-4.308-1.18-.731-2.93.163-3.296.366l-.977 7.295zM24.517 161.816s-5.312-3.191-4.742 4.064c.59 7.275 5.76 3.414 5.76 3.414l-1.018-7.478z'
          fill='#FFD2BA'
        />
        <path
          d='M22.767 170.491c-.367 0-.733-.061-1.08-.224-1.18-.528-1.871-1.991-2.055-4.369-.203-2.418.245-3.963 1.282-4.613 1.486-.914 3.603.346 3.684.386l.061.041 1.038 7.661-.081.061c-.041.061-1.405 1.057-2.85 1.057zm-.59-9.206c-.387 0-.754.081-1.1.285-.936.569-1.323 2.032-1.14 4.308.184 2.235.815 3.617 1.873 4.105 1.404.63 3.154-.488 3.541-.752l-.997-7.316c-.244-.142-1.2-.63-2.178-.63z'
          fill='#FFD2BA'
        />
        <path d='M31.681 171.914l9.117.02s-1.424 3.557-4.456 3.679c-3.033.122-4.417-2.967-4.66-3.699z' fill='#fff' />
        <path
          d='M36.158 175.777c-3.277 0-4.58-3.658-4.62-3.8l-.06-.204h.203l9.117.021h.081l.041.061c.061.081.04.101-.102.406-.386.793-1.852 3.414-4.477 3.516h-.183zm-4.274-3.719c.305.772 1.628 3.516 4.437 3.414 2.523-.102 3.907-2.662 4.253-3.394-1.262 0-7.428-.02-8.69-.02z'
          fill='#fff'
        />
        <path
          d='M59.786 194.107c-6.532 5.507-14.958 8.84-24.177 8.84a37.354 37.354 0 01-21.877-7.031c6.451-2.886 12.475-6.402 22.386-6.361 10.664.041 15.304 1.992 23.668 4.552z'
          fill='#152144'
        />
        <path
          d='M35.589 203.129c-7.958 0-15.549-2.439-21.98-7.072l-.244-.183.285-.122c.855-.386 1.73-.792 2.564-1.179 5.495-2.56 11.173-5.202 19.7-5.202h.204c9.3.041 14.042 1.524 20.595 3.597.997.305 2.035.63 3.134.975l.305.102-.244.203c-6.797 5.711-15.426 8.881-24.32 8.881zm-21.511-7.194c6.308 4.471 13.736 6.828 21.51 6.828 8.69 0 17.136-3.048 23.811-8.596-.977-.305-1.913-.589-2.828-.874-6.533-2.052-11.234-3.536-20.494-3.576h-.203c-8.426 0-14.083 2.621-19.538 5.161-.712.366-1.485.711-2.258 1.057z'
          fill='#152144'
        />
        <path d='M69 209.438c9.389 0 17-7.612 17-17 0-9.389-7.611-17-17-17s-17 7.611-17 17c0 9.388 7.611 17 17 17z' fill='#E4FCF5' />
        <path
          d='M75 193.438h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5h-5c-.55 0-1-.45-1-1 0-.551.45-1 1-1h5v-5c0-.551.45-1 1-1s1 .449 1 1v5h5c.55 0 1 .449 1 1 0 .55-.45 1-1 1z'
          fill='#000'
        />
        <mask
          id='SelfManagedModal_svg__a'
          style={{
            maskType: 'luminance',
          }}
          maskUnits='userSpaceOnUse'
          x={62}
          y={185}
          width={14}
          height={15}
        >
          <path
            d='M75 193.438h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5h-5c-.55 0-1-.45-1-1 0-.551.45-1 1-1h5v-5c0-.551.45-1 1-1s1 .449 1 1v5h5c.55 0 1 .449 1 1 0 .55-.45 1-1 1z'
            fill='#fff'
          />
        </mask>
        <g mask='url(#SelfManagedModal_svg__a)'>
          <path fill='#51D9B0' d='M57 180.438h24v24H57z' />
        </g>
        <mask
          id='SelfManagedModal_svg__b'
          style={{
            maskType: 'alpha',
          }}
          maskUnits='userSpaceOnUse'
          x={241}
          y={46}
          width={75}
          height={75}
        >
          <circle cx={278.091} cy={83.091} r={37.091} fill='#C4C4C4' />
        </mask>
        <g mask='url(#SelfManagedModal_svg__b)'>
          <path fill='#F3F5F9' d='M232.654 44.145h91.8v80.673h-91.8z' />
          <g clipPath='url(#SelfManagedModal_svg__clip2_37618_578201)'>
            <path
              d='M266.472 61.031s12.236-14.744 29.575 3.02c17.339 17.762 1.288 36.438 9.399 51.603 7.76 14.534 24.58 6.108 25.349 12.427 4.684 37.071-26.988 32.437-38.873 21.484-11.886-10.952-9.998-23.66-12.935-33.911-2.936-10.25-12.515-54.623-12.515-54.623z'
              fill='#00385E'
            />
            <path
              d='M269.268 60.96s-.209-.07-.489-.14c-1.748-.492-7.621-1.756-9.648 2.457-2.447 4.985 1.258 4.985-.49 11.584-1.818 6.6-.699 14.814 4.055 16.148 10.558 3.09 12.026-21.694 12.026-21.694l-5.454-8.355z'
              fill='#00385E'
            />
            <path
              d='M245.637 114.528s6.991-18.746 7.551-19.448c5.733-6.389 12.165-7.372 20.136-4.212 5.034 1.966 12.934 6.88 20.555 11.093 21.394 11.865 14.752 33.77 14.752 33.77l-2.377 5.196-3.636-8.846-1.048 6.389c-1.399 8.635-4.265 9.689-4.055 18.465.279 11.654-46.844 2.878-44.467-14.393l-7.411-28.014z'
              fill='#009DBD'
            />
            <path
              d='M277.659 100.417c-2.727.281-5.104-1.755-5.384-4.494l-1.258-13.901c-.28-2.738 1.747-5.125 4.474-5.406 2.727-.281 5.104 1.755 5.384 4.493l1.258 13.902c.21 2.738-1.748 5.195-4.474 5.406z'
              fill='#EDBFB2'
            />
            <path
              d='M266.962 88.344l-12.935 23.52c-3.915 4.212-2.797 10.18-2.727 11.163l2.517 28.084-7.061 67.12s18.038 19.448 42.159 8.917l-4.125-75.405 1.189-19.448c.489-8.425 3.006-16.64 7.271-23.942l3.496-5.827-8.53-4.072-8.879 12.638c-1.119 1.614-3.286 2.317-5.104 1.544l-6.083-2.387a4.396 4.396 0 01-2.447-5.827l6.083-14.183-4.824-1.895z'
              fill='#00537D'
            />
            <path
              d='M283.88 82.937c.07 6.74-10.277 10.532-16.15 7.162-5.873-3.3-5.034-10.391-5.034-17.131 0-7.653 8.949-11.304 14.822-8.004 5.873 3.37 6.292 11.233 6.362 17.973z'
              fill='#FFD2BA'
            />
            <path
              d='M285.839 79.143s-8.46-1.334-12.585-5.897c-4.125-4.564-6.013-8.215-3.845-9.69 2.167-1.473 17.968-4.422 16.43 15.587z'
              fill='#00385E'
            />
            <path opacity={0.3} d='M281.364 88.344s-3.776 2.668-9.579 2.949l.28 2.316c0 .07 5.663.562 9.299-5.265z' fill='#DE7566' />
          </g>
          <path
            d='M270.294 87.963c-3.202-.694-3.7-4.545-3.71-4.693l-.016-.211.199.043 8.906 1.952.079.017.027.068c.042.093.018.108-.186.376-.545.692-2.533 2.944-5.12 2.487l-.179-.039z'
            fill='#fff'
          />
        </g>
        <path d='M312 128c9.389 0 17-7.611 17-17s-7.611-17-17-17-17 7.611-17 17 7.611 17 17 17z' fill='#E4FCF5' />
        <path
          d='M318 112h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5h-5c-.55 0-1-.45-1-1s.45-1 1-1h5v-5c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1z'
          fill='#000'
        />
        <mask
          id='SelfManagedModal_svg__c'
          style={{
            maskType: 'luminance',
          }}
          maskUnits='userSpaceOnUse'
          x={305}
          y={104}
          width={14}
          height={14}
        >
          <path
            d='M318 112h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5h-5c-.55 0-1-.45-1-1s.45-1 1-1h5v-5c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1z'
            fill='#fff'
          />
        </mask>
        <g mask='url(#SelfManagedModal_svg__c)'>
          <path fill='#51D9B0' d='M300 99h24v24h-24z' />
        </g>
        <g filter='url(#SelfManagedModal_svg__filter3_d_37618_578201)'>
          <path
            d='M105.355 83.177c0 14.437-11.741 26.178-26.178 26.178C64.741 109.355 53 97.614 53 83.177 53 68.741 64.74 57 79.177 57s26.178 11.74 26.178 26.177z'
            fill='#fff'
          />
        </g>
        <path
          d='M63.229 85.365v1.397s1.797 0 1.757 1.518c-.04 1.517-1.757 1.637-1.757 1.637v4.013l28.531-6.629-.1-9.184-28.431 7.248z'
          fill='#FFE887'
        />
        <path d='M75.847 68.875L63.23 85.367l28.431-7.248-15.813-9.244z' fill='#F7A118' />
        <path d='M75.728 67.516L63.109 84.007l28.532-7.267-15.913-9.224z' fill='#FDC56B' />
        <path
          d='M76.785 90.677s-.26-2.596 1.857-2.835c2.117-.24 1.598 2.036 1.598 2.036l-3.454.799zM82.556 80.415s1.458 2.416 4.512 1.817c3.075-.6 2.676-3.654 2.676-3.654l-7.188 1.837z'
          fill='#EDB05A'
        />
        <path d='M63.23 85.364l-.12-1.358 28.53-7.268v1.378l-28.41 7.248z' fill='#FFF0B5' />
        <path d='M90.522 77.018V87.58l1.238-.28-.12-10.562-1.118.28z' fill='#FDC56B' />
        <g filter='url(#SelfManagedModal_svg__filter4_d_37618_578201)'>
          <path
            d='M302.893 195.37c14.457 0 26.177-11.72 26.177-26.177 0-14.457-11.72-26.177-26.177-26.177-14.457 0-26.177 11.72-26.177 26.177 0 14.457 11.72 26.177 26.177 26.177z'
            fill='#fff'
          />
        </g>
        <path
          d='M302.664 167.931a.26.26 0 01-.042.295c-.126.168-.42.252-.63.168-.042 0-4.495-1.556-7.772-1.22-.252.042-.42-.084-.42-.252 0-.168.252-.336.462-.378 3.571-.379 8.066 1.177 8.234 1.261.126 0 .168.042.168.126z'
          fill='#17916F'
        />
        <path
          d='M303.168 167.508c.042.084 0 .21-.126.295-.168.168-.462.21-.63.084l-8.485-4.668c-.168-.084-.168-.295 0-.421.168-.168.462-.21.63-.084l8.485 4.668c.084.042.126.084.126.126z'
          fill='#17916F'
        />
        <path
          d='M303.589 166.541c.042.084 0 .21-.085.295-.168.168-.462.21-.63.126-.042-.042-1.47-.715-3.57-3.365-.126-.126 0-.336.21-.462s.504-.084.588.042c2.016 2.523 3.36 3.196 3.402 3.196 0 .084.042.126.085.168z'
          fill='#31A88E'
        />
        <path
          d='M289.6 159.142c-.588-1.346-1.597-.799-1.387-.294.21.504.042.715-.546.63-.63-.042-1.302-1.934-1.848-1.808-.546.126.084.589-.084.883-.168.337-.63.211-1.974-.294-1.723-.673-1.681.042-1.681.042s-.168.799 1.429 1.219c1.386.379 1.764.757 1.764 1.136 0 .378-.714.294-.294.799.378.505 1.722-.589 2.268-.168.546.378.588.673.21.967-.378.252.252 1.472 1.303.757 1.008-.715 1.512-.757 1.974-.252.462.546-.588.462-.336.883.252.42.882.504 1.764-.21.672-.547 1.765-.211 2.269-.042.126.042.294 0 .294-.127.042-.126-.084-.294-.21-.336-.504-.21-1.513-.715-1.891-1.682-.462-1.262-1.008-1.682-1.386-1.472-.378.168.504.883-.084 1.009-.588.084-.966-.336-1.554-1.64z'
          fill='#20CC9C'
        />
        <path
          d='M299.472 157.669c.63-1.304-.504-1.64-.714-1.136-.253.505-.505.547-.883.085-.378-.463.588-2.229.084-2.482-.504-.252-.378.463-.714.589-.336.126-.588-.252-1.134-1.556-.672-1.598-1.176-1.093-1.176-1.093s-.714.462.042 1.808c.672 1.177.672 1.724.378 1.977-.294.252-.714-.253-.84.378s1.638.757 1.68 1.388c.084.631-.126.883-.588.799-.462-.042-.924 1.219.336 1.388 1.218.21 1.638.462 1.554 1.135-.084.673-.756-.042-.924.421-.168.462.252.925 1.386 1.051.883.084 1.387 1.009 1.597 1.472.042.126.21.168.294.126a.339.339 0 00.126-.378c-.168-.463-.504-1.556-.042-2.44.63-1.177.546-1.85.168-1.976-.42-.126-.336.967-.798.631-.504-.337-.42-.883.168-2.187z'
          fill='#17916F'
        />
        <path
          d='M288.256 165.195c-1.092-1.051-1.638-.042-1.218.336.42.421.378.673-.126.884-.504.21-1.933-1.304-2.311-.926-.336.379.336.547.378.926.042.378-.378.504-1.68.588-1.638.169-1.26.799-1.26.799s.252.841 1.68.547c1.26-.294 1.722-.084 1.932.294.168.379-.42.631.168.926.547.336 1.051-1.346 1.681-1.22.63.126.798.421.63.841-.168.463.924 1.304 1.386.168.462-1.177.798-1.472 1.428-1.135.63.294-.21.715.21 1.051.42.337.925.084 1.261-1.051.252-.841 1.26-1.051 1.722-1.094.126 0 .21-.126.168-.294a.366.366 0 00-.336-.252c-.462.042-1.554 0-2.268-.799-.967-1.052-1.597-1.178-1.807-.799-.21.378.84.631.42 1.009-.462.505-.966.252-2.058-.799z'
          fill='#116B52'
        />
        <path
          d='M321.61 177.559c-.462 1.136-2.185.589-3.025.253l-14.409-5.299c-3.486-1.683-2.562-4.332-2.562-4.332 1.05-2.019 4.369-3.869 6.217-2.523l12.056 8.999c.714.505 2.185 1.725 1.723 2.902z'
          fill='#ED934E'
        />
        <path
          d='M309.427 171.926c.042.084 0 .21-.126.336-.42.337-.63.715-.63.967 0 .084.042.169.168.211.21.084.252.252.084.42-.126.168-.42.252-.63.168-.294-.126-.504-.336-.504-.588-.042-.421.294-1.01.924-1.472.168-.126.462-.169.63-.084.042-.042.084 0 .084.042z'
          fill='#ED934E'
        />
        <path
          d='M315.562 171.507c.042.168-.084.337-.336.421-.42.126-.714.42-.672.631.042.168-.168.336-.378.42-.252.042-.462-.042-.504-.21-.084-.505.504-1.136 1.344-1.43.252-.042.504.042.546.168zM319.3 176.762c.042.085 0 .169-.084.295-.294.294-.21.378-.168.378.168.126.084.295-.084.463-.21.126-.462.168-.63.042-.21-.168-.42-.505.168-1.136.168-.168.42-.21.63-.168.084.042.126.084.168.126zM307.915 165.871c.042.126-.042.295-.252.379-.798.42-1.218.883-1.26 1.43 0 .168-.252.336-.462.378-.252.042-.42-.084-.42-.252.084-.799.672-1.472 1.722-2.019.21-.126.504-.084.588.042.084 0 .084.042.084.042z'
          fill='#C77C11'
        />
        <path
          d='M302.581 174.029c.126 0 .21-.084.252-.168.084-.168 0-.336-.168-.42-.042 0-3.655-1.514-4.999-3.407-.084-.126-.294-.168-.462-.084-.168.084-.21.294-.084.421 1.428 2.018 5.125 3.532 5.251 3.616.084.042.126.042.21.042z'
          fill='#17916F'
        />
        <path
          d='M302.413 174.49a.43.43 0 00.252-.21c.042-.168-.042-.337-.21-.379l-8.612-1.976c-.168-.042-.336.042-.42.21-.042.168.042.336.21.379l8.612 1.976h.168zM301.74 175.163c.084-.042.21-.084.21-.21.042-.168-.042-.336-.21-.378-.042 0-1.386-.421-4.915-.127-.168 0-.336.169-.294.337 0 .168.168.294.336.294 3.361-.252 4.663.126 4.663.126.084 0 .168 0 .21-.042z'
          fill='#17916F'
        />
        <path
          d='M287.878 171.757c-1.512.378-1.554-.421-.966-.547.588-.168.672-.336.336-.631-.378-.294-2.437.337-2.563-.042-.126-.336.589-.252.799-.504.21-.253-.126-.421-1.261-.842-1.47-.546-.798-.883-.798-.883s.672-.504 1.849.126c1.05.505 1.596.547 1.932.337.336-.21-.084-.505.588-.547.672-.042.336 1.178.966 1.262.63.084.924-.042 1.008-.379.084-.336 1.513-.588 1.345.295-.126.883.042 1.177.756 1.135.714-.042.126-.547.672-.631.546-.084.882.211.672 1.01-.168.631.672 1.009 1.092 1.177.126.042.126.126.042.21-.126.085-.294.127-.42.085a4.218 4.218 0 00-2.52-.127c-1.387.421-2.059.337-2.101.042 0-.294 1.092-.168.882-.546-.21-.379-.798-.379-2.31 0zM291.406 177.603c-.924 1.009-1.764.589-1.428.21.336-.378.252-.546-.378-.504-.63.042-1.806 1.429-2.268 1.303-.504-.126.252-.42.168-.673-.042-.252-.546-.168-2.017.211-1.848.462-1.596-.042-1.596-.042s.042-.589 1.722-.884c1.429-.252 1.933-.546 2.017-.841.084-.294-.588-.21-.084-.588.546-.379 1.512.462 2.142.168.63-.295.756-.505.462-.715-.294-.21.672-1.094 1.47-.547.799.547 1.261.589 1.849.21.588-.378-.42-.336-.084-.672.378-.337 1.008-.337 1.68.21.504.42 1.638.21 2.185.084.168-.042.252 0 .252.084s-.126.21-.294.252c-.547.127-1.681.505-2.311 1.22-.798.925-1.428 1.22-1.764 1.093-.336-.126.756-.672.168-.757-.462-.126-.966.169-1.891 1.178zM292.835 167.973c-1.513-.042-.883-.799-.294-.799.588 0 .84-.126.798-.505-.042-.378-2.185-.336-2.017-.715.21-.378.672-.084 1.051-.252.378-.168.294-.463-.253-1.178-.672-.925.127-1.051.127-1.051s.924-.294 1.344.589c.378.799.798.925 1.26.841.462-.084.378-.505.966-.379s-.756 1.22-.294 1.472c.42.252.756.21 1.092-.084.336-.294 1.681-.21.84.631-.882.841-.966 1.135-.378 1.304.589.168.547-.463 1.051-.421.504.042.546.421-.336 1.178-.673.588-.337 1.177-.168 1.429.042.085 0 .169-.169.211-.168.042-.336.042-.378-.042-.21-.253-.798-.799-1.89-.757-1.428.042-1.89-.211-1.68-.505.252-.294 1.008.084 1.176-.294.168-.505-.294-.631-1.848-.673z'
          fill='#20CC9C'
        />
        <path
          d='M320.98 178.864c.84-.799-.546-1.43-1.26-1.683l-12.098-4.71c-3.277-.967-5.293.883-5.293.883-1.387 1.556-1.429 4.248 1.092 5.005l14.282 1.64c1.597 0 2.437-.294 3.277-1.135z'
          fill='#F7C066'
        />
        <path
          d='M309.679 175.459a.43.43 0 00.252-.21c.126-.378.336-.673.588-.799a.268.268 0 01.252 0c.168.084.378 0 .42-.168.084-.168 0-.337-.168-.421-.252-.126-.546-.084-.84.042-.42.211-.756.673-.924 1.22-.042.168.042.336.252.378.042-.042.126-.042.168-.042zM312.326 178.823c.168-.042.294-.21.252-.378-.084-.295.042-.589.252-.673.168-.084.252-.252.168-.421-.084-.168-.252-.21-.42-.168-.546.21-.798.841-.63 1.43.042.168.21.252.378.21zM319.089 178.067c.084-.042.168-.084.21-.168.126-.294.252-.294.294-.294a.403.403 0 00.378-.295c.042-.168-.084-.336-.294-.336-.252-.042-.672.042-.966.673-.084.168 0 .336.168.42h.21zM303.294 177.773a.367.367 0 00.252-.337c0-.631.21-1.051.714-1.388.168-.084.21-.294.084-.42-.084-.126-.294-.168-.462-.084-.715.462-1.051 1.093-1.051 1.934 0 .168.168.295.336.295h.127z'
          fill='#ED934E'
        />
        <g filter='url(#SelfManagedModal_svg__filter5_d_37618_578201)'>
          <path
            d='M221.883 248.019c14.457 0 26.177-11.72 26.177-26.178 0-14.457-11.72-26.177-26.177-26.177-14.457 0-26.177 11.72-26.177 26.177 0 14.458 11.72 26.178 26.177 26.178z'
            fill='#fff'
          />
        </g>
        <path
          d='M207.048 225.675s.177 1.736 1.008 3.572c1.057 2.264 7.303 4.83 15.286 2.34 3.5-1.082 5.263-1.56 6.749-2.214 5.892-2.641 8.008-7.899 7.328-12.276l-.076-.73-30.295 9.308z'
          fill='#393420'
        />
        <path
          d='M232.559 211.537c1.133.503 2.115 1.107 2.921 1.811 2.644 2.315 2.493 4.906-.403 7.296-1.838 1.509-4.357 2.289-6.573 2.993-1.964.604-3.802 1.183-5.213 2.214-4.407 3.195-8.738 3.371-10.904 3.195a9.095 9.095 0 01-2.871-.679c-.831-.378-1.485-.856-1.888-1.409-.831-1.157-1.562-3.572 2.845-6.792 1.411-1.032 1.939-2.189 2.493-3.421.63-1.384 1.36-2.969 3.476-4.352 3.349-2.189 7.731-2.919 12.339-2.013 1.36.252 2.644.654 3.778 1.157z'
          fill='#7AC3B2'
        />
        <path
          d='M232.055 211.913c1.083.477 2.015 1.056 2.77 1.71 2.518 2.189 2.367 4.654-.378 6.918-1.737 1.434-4.13 2.189-6.245 2.843-1.864.578-3.626 1.132-4.961 2.113-4.206 3.069-8.31 3.245-10.375 3.094-1.008-.075-1.94-.302-2.745-.654-.781-.352-1.411-.805-1.788-1.333-.806-1.132-1.486-3.421 2.694-6.491 1.335-.981 1.839-2.088 2.367-3.245.605-1.333 1.31-2.842 3.299-4.15 3.199-2.088 7.354-2.768 11.736-1.912 1.309.251 2.543.629 3.626 1.107z'
          fill='#51D9B0'
        />
        <path
          d='M212.89 220.945c-3.299 2.415-2.896 4.1-2.266 4.956.251.327.629.629 1.133.83.504.226 1.083.352 1.712.402 1.612.126 4.609-.075 7.908-2.465 3.399-2.49 8.411-2.641 11.105-4.855 2.594-2.138 1.738-4 .252-5.283-1.259-1.107-3.097-1.912-5.288-2.34-2.594-.503-5.969-.528-8.965 1.434-3.148 2.038-2.191 4.83-5.591 7.321z'
          fill='#C7F3C8'
        />
        <path
          d='M224.379 220.384c2.738-1.015 4.503-3.063 3.942-4.574-.562-1.511-3.236-1.913-5.974-.898-2.739 1.015-4.503 3.063-3.942 4.574.561 1.511 3.236 1.913 5.974.898z'
          fill='#393420'
        />
        <path
          d='M223.165 217.802c-.73.579-1.612.654-1.989.176-.378-.478-.076-1.333.629-1.887.73-.578 1.612-.654 1.99-.176.377.453.1 1.308-.63 1.887z'
          fill='#6D6853'
        />
      </g>
      <defs>
        <filter
          id='SelfManagedModal_svg__filter0_d_37618_578201'
          x={120}
          y={40}
          width={92.355}
          height={92.356}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={10} />
          <feColorMatrix values='0 0 0 0 0.0235294 0 0 0 0 0.470588 0 0 0 0 0.658824 0 0 0 0.2 0' />
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_37618_578201' />
          <feBlend in='SourceGraphic' in2='effect1_dropShadow_37618_578201' result='shape' />
        </filter>
        <filter
          id='SelfManagedModal_svg__filter1_d_37618_578201'
          x={98}
          y={132}
          width={92.355}
          height={92.356}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={10} />
          <feColorMatrix values='0 0 0 0 0.0235294 0 0 0 0 0.470588 0 0 0 0 0.658824 0 0 0 0.2 0' />
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_37618_578201' />
          <feBlend in='SourceGraphic' in2='effect1_dropShadow_37618_578201' result='shape' />
        </filter>
        <filter
          id='SelfManagedModal_svg__filter2_d_37618_578201'
          x={174}
          y={108}
          width={92.355}
          height={92.356}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={10} />
          <feColorMatrix values='0 0 0 0 0.0235294 0 0 0 0 0.470588 0 0 0 0 0.658824 0 0 0 0.2 0' />
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_37618_578201' />
          <feBlend in='SourceGraphic' in2='effect1_dropShadow_37618_578201' result='shape' />
        </filter>
        <filter
          id='SelfManagedModal_svg__filter3_d_37618_578201'
          x={33}
          y={41}
          width={92.355}
          height={92.356}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={10} />
          <feColorMatrix values='0 0 0 0 0.0235294 0 0 0 0 0.470588 0 0 0 0 0.658824 0 0 0 0.2 0' />
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_37618_578201' />
          <feBlend in='SourceGraphic' in2='effect1_dropShadow_37618_578201' result='shape' />
        </filter>
        <filter
          id='SelfManagedModal_svg__filter4_d_37618_578201'
          x={256.716}
          y={127.016}
          width={92.355}
          height={92.356}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={10} />
          <feColorMatrix values='0 0 0 0 0.0235294 0 0 0 0 0.470588 0 0 0 0 0.658824 0 0 0 0.2 0' />
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_37618_578201' />
          <feBlend in='SourceGraphic' in2='effect1_dropShadow_37618_578201' result='shape' />
        </filter>
        <filter
          id='SelfManagedModal_svg__filter5_d_37618_578201'
          x={175.706}
          y={179.664}
          width={92.355}
          height={92.356}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={10} />
          <feColorMatrix values='0 0 0 0 0.0235294 0 0 0 0 0.470588 0 0 0 0 0.658824 0 0 0 0.2 0' />
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_37618_578201' />
          <feBlend in='SourceGraphic' in2='effect1_dropShadow_37618_578201' result='shape' />
        </filter>
        <clipPath id='SelfManagedModal_svg__clip0_37618_578201'>
          <path fill='#fff' d='M0 0h352v280H0z' />
        </clipPath>
        <clipPath id='SelfManagedModal_svg__clip1_37618_578201'>
          <path fill='#fff' transform='translate(121.795 164.141)' d='M0 0h43v19H0z' />
        </clipPath>
        <clipPath id='SelfManagedModal_svg__clip2_37618_578201'>
          <path fill='#fff' transform='translate(245.636 55.273)' d='M0 0h91.8v175.032H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgSelfManagedModal;
